import React, { useEffect, useState, PureComponent } from 'react';
import { ScatterChart, Scatter, CartesianGrid, Tooltip, ResponsiveContainer, ZAxis, LineChart } from 'recharts';
import { XYPlot, XAxis, YAxis, HorizontalGridLines, VerticalGridLines, MarkSeries, LineSeries } from 'react-vis';
import { PartialDischargeGraphXYDataModel } from './../PartialDischarge';


type PartialDischargeGraphLeftChartProps = {
  phaseCharacteristicsGraphList: PartialDischargeGraphXYDataModel[] | undefined;
};

type XYSizeItem = {
  x: number;
  y: number;
  size: number;
}

const PartialDischargeGraphLeftChart: React.FC<PartialDischargeGraphLeftChartProps> = (props) => {
  console.debug(["PartialDischargeGraphLeftChart-start"]);

  /**
   * グラフ表示の値を入手
   * @returns 
   */
  const GetXYItems = (): XYSizeItem[] => {
    let dataList: XYSizeItem[] = [];
    let tempList = props.phaseCharacteristicsGraphList;

    if (tempList !== undefined) {
      tempList.map((row, index) => {
        let xValue = row.XValue !== undefined ? row.XValue : 0;
        let yValue = row.YValue !== undefined ? row.YValue : 0;
        let sizeValue = row.Size !== undefined ? row.Size : 1;
        dataList.push({
          x: xValue,
          y: yValue,
          size: sizeValue
        })
      });
      console.debug(["PartialDischargeGraphLeftChart --dataList--",
        props.phaseCharacteristicsGraphList, dataList, tempList]);
    }

    return dataList;
  }

  return (
    <>
      {props.phaseCharacteristicsGraphList !== undefined ?
        <ResponsiveContainer width="100%" height="100%">
          <XYPlot width={100} height={100} xDomain={[0, 360]} yDomain={[0, 10]} margin={{ right: 20 }}>
            <VerticalGridLines style={{ stroke: '#B7E9ED' }} />
            <HorizontalGridLines style={{ stroke: '#B7E9ED' }} />
            <XAxis />
            <YAxis />
            <MarkSeries
              className="mark-series-example"
              strokeWidth={2}
              opacity={1}
              sizeRange={[1, 1]}
              data={GetXYItems()}
              color={"#662d86"}
            />
          </XYPlot>
        </ResponsiveContainer>
        : null}
    </>
  );
}
export default PartialDischargeGraphLeftChart;

